/*
SVG Sprite
*/
const files = require.context(__dirname, false, /\.svg$/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./client/src/site__evo/sprites/index.js